<ion-item [ngClass]="{'closed': communication.cerrado}">

  <ion-thumbnail slot="start">
    <yu-icon
      [ngStyle]="{'color': communication.color, 'background': communication.color + '1a'}"
      [name]="communication.id_subtipo | communicationIcon"
    ></yu-icon>
  </ion-thumbnail>

  <ion-label>
    <p class="title">{{ communication.titulo }}</p>

    <p class="description">
      @if (communication.local) {
        <span>{{ communication.local }} | </span>
      }

      @if (communication.comentarios && communication.comentarios.length) {
        <span>{{ communication.comentarios[0].usuario }}:</span> {{ communication.comentarios[0].comentario }}

      } @else {
        {{ 'ITEMS.COMMUNICATION.NO_COMMENTS' | translate }}
      }
    </p>
  </ion-label>

  @if (communication.not) {
    <yu-badge color="error" slot="end">{{ communication.not }}</yu-badge>
  }

  <div class="date">
    @if (communication.comentarios && communication.comentarios.length) {
      {{ communication.comentarios[0].fecha_formated }}

    } @else {
      {{ communication.fecha | date: 'dd/MM/yyyy' }}
    }
  </div>

</ion-item>
